export { default } from './DenFraudesBoletoSeguro';
